<div class="white">
  <webu-stepper-heading
    id="stepper"
    [steps]="getSteps()"
    [currentStep]="getCurrentStep()"
    [returnState]="getReturnState()"
    [isUpdatePlanComponent]="true"
    [baseTrackingString]="'shop:review changes:link:shop'"
    [upgradeDowngradeTrackingString]="'shop:update plan:link:my plans'"
    [p15AnalyticsString]="'my plans'">
  </webu-stepper-heading>
  <div *ngIf="!isLoading && isError"> 
    <error-state-gm-web-shop 
      [errorText1]="'manage_plans_errorHeadline' | translate"
      [errorText2]=" 'manage_plans_errorSubheadline' | translate"
      >
    </error-state-gm-web-shop>
    <br>
  </div>
  <div class="container white">
    <ox-loading *ngIf="isLoading"></ox-loading>
    <div *ngIf="updatePlanData && !isLoading && !isError">      
      <div class="row mobilepading">
        <div class="col-12 col-lg-6 p-0">
          <div *ngIf="activeVehicle$ | async as vehicle" id="div-headline" class="gb-headline1 mt-9">
            {{ getCopy('plan.update') }} {{ vehicle.model }}
          </div>
        </div>
      </div>
      <div class="row mt-8 mobilepading">
        <div class="col-12 p-0">
          <div class="cit2-tab-container">
            <input
              type="radio"
              class="state"
              id="tab-one"
              name="tabs-state"
              [checked]="tabSelected === 0"
              value="0"
              (change)="fireTracking('featured');"
            />
            <input
              type="radio"
              class="state"
              id="tab-two"
              name="tabs-state"
              [checked]="tabSelected === 1"
              value="1"
              (change)="fireTracking('build your own');"
            />

            <div *ngIf="!isLoading" class="cit2-tabs">
              <div class="tab-labels" *ngIf="updatePlanData.byoCopy">
                <label
                  for="tab-one"
                  id="tab-one-label"
                  class="tab gb-body1 heavy"
                  >{{ updatePlanData.featuredCopy?.tabLabel }}</label
                >
                <label
                  for="tab-two"
                  id="tab-two-label"
                  class="tab gb-body1 heavy"
                  >{{ updatePlanData.byoCopy.tabLabel }}</label
                >
              </div>

              <div id="tab-one-content" class="panel active">
                <webu-manage-feature-plan
                  [(selectedProduct)]="selectedProduct"
                  [products]="products"
                  [copy]="copy"
                  [updatePlanData]="updatePlanData"
                  *ngIf="copy"
                ></webu-manage-feature-plan>
              </div>
              <div id="tab-two-content" class="panel">
                <webu-build-your-own *ngIf="copy"
                  [(selectedProduct)]="selectedProduct"
                  (selectedProductAndResidue)="selectedProductAndResidue($event)"
                  [products]="products"
                  [copy]="copy"
                  [updatePlanData]="updatePlanData"
                  addtext="{{ getCopy('add.button.copy') }}"
                  addAndSavetext="{{ getCopy('add.and.save.button.copy') }}"
                  removetext="{{ getCopy('remove.button.copy') }}"
                ></webu-build-your-own>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="padding-bottom: 150px">
        <div class="col p-0">
          <hr class="cit" />
          <webu-chat-footer></webu-chat-footer>
        </div>
      </div>
    </div>
  </div>

  <webu-payment-footer
    *ngIf="footerObj"
    trackingString="shop"
    planStatus="update plan"
    continueButtonSubString="shop:update plan:"
    footerString=":footer"
    buttonName="Continue"
    [planName]="footerObj.selectedProductName"
    [planDisclosure]="footerObj.selectedProductDisclosure"
    [isMonthly]="true"
    [planCount]="footerObj.planCount"
    [price]="footerObj.price"
    (continueButton)="onFooterButtonClick()"
    [priceDisclosure]="footerObj.priceDisclosure"
    [selectedBYO]="footerObj.selectedBYO"
    [residueBYO]="footerObj.residueBYO"
    [offerIds]="footerObj.offerIds"
    [doHideFrequencyText]="false"
    [buttonLoading]="isCheckoutLoading"
  >
  </webu-payment-footer>
</div>